export const truncarValor = (valor) => {
  const [inteiro, dizima] = valor.toString().split('.');

  return !dizima || dizima.length < 3
    ? valor.toFixed(2)
    : `${inteiro}.${dizima.slice(0, 2)}`;
};

export const obterValorMonetario = (valor) => `R$ ${truncarValor(valor)}`;
